// extracted by mini-css-extract-plugin
module.exports = {"bet-choice":"bet-options_bet-choice__3lWac","even":"bet-options_even__3NO_s","odd":"bet-options_odd__W1WBC","layout-special-sedie":"bet-options_layout-special-sedie__18VUn"};